import { fetchApi, CONSUMABLE_BALANCES_API, CONSUMABLES_API } from '@/api/client'
import type { RedisBalanceEntry, LiveCampaignEventCounts } from '../types/balanceInspector.types'
import type { EventConsumptionRow } from '@/api/types'

export async function getRedisBalances(accountId: string): Promise<RedisBalanceEntry[]> {
  return fetchApi<RedisBalanceEntry[]>(`${CONSUMABLE_BALANCES_API}/${accountId}/redis`)
}

/** date defaults server-side to today (yyyy-MM-dd) when omitted. */
export async function getAccountDailyConsumables(accountId: string, date?: string): Promise<EventConsumptionRow> {
  const q = date ? `?date=${date}` : ''
  return fetchApi<EventConsumptionRow>(`${CONSUMABLES_API}/report/account/${accountId}${q}`)
}

/** startDate/endDate default server-side to today when omitted. */
export async function getLiveCampaignEventCounts(
  accountId: string,
  startDate?: string,
  endDate?: string,
): Promise<LiveCampaignEventCounts> {
  const q = new URLSearchParams()
  if (startDate) q.set('startDate', startDate)
  if (endDate) q.set('endDate', endDate)
  const qs = q.toString() ? `?${q.toString()}` : ''
  return fetchApi<LiveCampaignEventCounts>(`${CONSUMABLES_API}/live-counts/account/${accountId}${qs}`)
}
